import {
  endOfWeek,
  endOfMonth,
  startOfDay,
  startOfWeek,
  startOfMonth,
  startOfToday,
  formatRFC3339,
  startOfYesterday,
} from 'date-fns';

import { TranslationKey } from '@lib/translation';

interface IDateRangeOption {
  value: string;
  label: TranslationKey;
  startDate?: Date;
  endDate?: Date;
  lightStartDate?: string;
  lightEndDate?: string;
}

export const SN_DATE_RANGE_OPTIONS: IDateRangeOption[] = [
  {
    value: 'today',
    label: 'common.today',
    startDate: startOfDay(new Date()),
    lightStartDate: formatRFC3339(startOfDay(new Date())),
  },
  {
    value: 'yesterday',
    label: 'common.yesterday',
    startDate: startOfYesterday(),
    endDate: startOfToday(),
    lightStartDate: formatRFC3339(startOfYesterday()),
    lightEndDate: formatRFC3339(startOfToday()),
  },
  {
    value: 'week',
    label: 'common.week',
    startDate: startOfWeek(new Date()),
    endDate: endOfWeek(new Date()),
    lightStartDate: formatRFC3339(startOfWeek(new Date())),
    lightEndDate: formatRFC3339(endOfWeek(new Date())),
  },
  {
    value: 'month',
    label: 'common.month',
    startDate: startOfMonth(new Date()),
    endDate: endOfMonth(new Date()),
    lightStartDate: formatRFC3339(startOfMonth(new Date())),
    lightEndDate: formatRFC3339(endOfMonth(new Date())),
  },
];

export const SN_DATE_RANGE_OPTION_MAP: Map<string, IDateRangeOption> = getDateRangeOptionMap();

function getDateRangeOptionMap(): Map<string, IDateRangeOption> {
  const map = new Map();
  SN_DATE_RANGE_OPTIONS.forEach((option) => {
    map.set(option.value, option);
  });

  return map;
}
